export enum TextInputType{
  TEXT = 'text',
  NUMBER = 'number',
  PASSWORD = 'password',
  EMAIL = 'email',
  TEL = 'tel',
  SEARCH = 'search',
  TEXT_AREA = 'textarea',
}
